const Button = ({ text, navigate }) => {
  const scrollTo = (section) => {
    if (section === "projects") {
      window.scrollTo(0, 860);
    }
  };
  return (
    <button
      onClick={() => scrollTo(navigate)}
      className="self-center px-3 py-2 text-sm font-light tracking-widest duration-300 ease-linear bg-transparent border border-gray-900 cursor-pointer sm:self-start md:self-start lg:text-base md:px-4 md:py-3 dark:border-highlight dark:text-highlight font-secondary text-md dark:hover:bg-highlightHover hover:bg-slate-900 hover:text-gray-200">
      {text}
    </button>
  );
};

export default Button;
